export const isWebEnvironment = (): boolean =>
  typeof window !== 'undefined' && typeof document !== 'undefined';
